module.exports = __webpack_public_path__ + "img/位图备份_17.c8fc7da6.jpg";